import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from "react";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
export function usePagination(_ref) {
  var _items$data, _items$pageInfo;

  var items = _ref.items,
      fetchMore = _ref.fetchMore,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? LIST_PAGE_LIMIT : _ref$limit,
      maxLength = _ref.maxLength,
      _ref$loadMore = _ref.loadMore,
      loadMore = _ref$loadMore === void 0 ? true : _ref$loadMore;
  var dataLength = (items === null || items === void 0 ? void 0 : (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) || 0;
  var hasNextPage = items === null || items === void 0 ? void 0 : (_items$pageInfo = items.pageInfo) === null || _items$pageInfo === void 0 ? void 0 : _items$pageInfo.hasNextPage;
  var maxLengthValid = !maxLength || maxLength && dataLength < maxLength;
  var enableLoadMore = loadMore && hasNextPage && maxLengthValid;
  var fetchMoreCallback = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(loadMore && hasNextPage)) {
              _context.next = 4;
              break;
            }

            if (maxLength && dataLength + limit > maxLength) {
              limit = maxLength - dataLength;
            }

            _context.next = 4;
            return fetchMore({
              variables: {
                offset: dataLength,
                limit: limit
              }
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [loadMore, dataLength, hasNextPage, fetchMore]);
  return {
    enableLoadMore: enableLoadMore,
    fetchMoreCallback: fetchMoreCallback
  };
}